module.exports = __webpack_public_path__ + "media/images/top/img_tab_chariloto-39bd749d362cedc58243430cced9909f.png";